// src/pages/Profile/Profile.jsx
import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth.js';
import { useToast } from '../../hooks/useToast.js';
import { Breadcrumbs } from '../../components/common/Breadcrumbs/Breadcrumbs';
import { Button } from '../../components/ui/Button/Button.jsx';
import { Input } from '../../components/ui/Input/Input.jsx';

export const Profile = () => {
  const { user, updateProfile, changePassword, isLoading } = useAuth();
  const { success, error } = useToast();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    first_name: user?.first_name || '',
    last_name: user?.last_name || '',
    phone: user?.phone || '',
    email: user?.email || '',
  });
  const [passwordData, setPasswordData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: '',
  });

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    try {
      await updateProfile(formData);
      success('Профиль обновлен');
      setIsEditing(false);
    } catch (err) {
      error('Не удалось обновить профиль');
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (passwordData.new_password !== passwordData.confirm_password) {
      error('Пароли не совпадают');
      return;
    }
    try {
      await changePassword({
        current_password: passwordData.current_password,
        new_password: passwordData.new_password,
      });
      success('Пароль изменен');
      setPasswordData({
        current_password: '',
        new_password: '',
        confirm_password: '',
      });
    } catch (err) {
      error(err.response?.data?.message || 'Не удалось изменить пароль');
    }
  };

  const breadcrumbs = [{ label: 'Профиль', path: '/profile' }];

  return (
    <div style={{ backgroundColor: 'rgb(var(--c-bg))', minHeight: '100vh', paddingBottom: '40px' }}>
      <div className="container" style={{ paddingTop: '24px' }}>
        <Breadcrumbs items={breadcrumbs} />

        <h1 style={{
          fontSize: '32px',
          fontWeight: 700,
          color: 'rgb(var(--c-text))',
          marginTop: '24px',
          marginBottom: '32px',
        }}>
          Профиль
        </h1>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '32px',
        }}>
          {/* Личные данные */}
          <div style={{
            backgroundColor: 'rgb(var(--c-surface))',
            border: '1px solid rgb(var(--c-border))',
            borderRadius: '16px',
            padding: '24px',
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '16px',
            }}>
              <h3 style={{
                fontSize: '18px',
                fontWeight: 600,
                color: 'rgb(var(--c-text))',
              }}>
                Личные данные
              </h3>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setIsEditing(!isEditing)}
              >
                {isEditing ? 'Отменить' : 'Редактировать'}
              </Button>
            </div>

            <form onSubmit={handleUpdateProfile}>
              <Input
                label="Имя"
                value={formData.first_name}
                onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                disabled={!isEditing}
              />
              <div style={{ height: '12px' }} />

              <Input
                label="Фамилия"
                value={formData.last_name}
                onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                disabled={!isEditing}
              />
              <div style={{ height: '12px' }} />

              <Input
                label="Телефон"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                disabled={!isEditing}
              />
              <div style={{ height: '12px' }} />

              <Input
                label="Email"
                value={formData.email}
                disabled
                style={{ backgroundColor: 'rgb(var(--c-surface-2))' }}
              />
              <div style={{ height: '20px' }} />

              {isEditing && (
                <Button type="submit" fullWidth isLoading={isLoading}>
                  Сохранить изменения
                </Button>
              )}
            </form>
          </div>

          {/* Изменение пароля */}
          <div style={{
            backgroundColor: 'rgb(var(--c-surface))',
            border: '1px solid rgb(var(--c-border))',
            borderRadius: '16px',
            padding: '24px',
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: 600,
              color: 'rgb(var(--c-text))',
              marginBottom: '16px',
            }}>
              Изменение пароля
            </h3>

            <form onSubmit={handleChangePassword}>
              <Input
                label="Текущий пароль"
                type="password"
                value={passwordData.current_password}
                onChange={(e) => setPasswordData({ ...passwordData, current_password: e.target.value })}
                required
              />
              <div style={{ height: '12px' }} />

              <Input
                label="Новый пароль"
                type="password"
                value={passwordData.new_password}
                onChange={(e) => setPasswordData({ ...passwordData, new_password: e.target.value })}
                required
              />
              <div style={{ height: '12px' }} />

              <Input
                label="Подтверждение пароля"
                type="password"
                value={passwordData.confirm_password}
                onChange={(e) => setPasswordData({ ...passwordData, confirm_password: e.target.value })}
                required
              />
              <div style={{ height: '20px' }} />

              <Button type="submit" fullWidth isLoading={isLoading}>
                Изменить пароль
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};